import { createSelector } from "@reduxjs/toolkit";

export const persistentValuesSelector = createSelector(
  (state) => state.persistentValues,
  (persistentValues) => {
    return { ...persistentValues };
  },
);
